import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import * as R from 'ramda';
import { TranslateService } from '@ngx-translate/core';
import { SideFormDialogComponent } from '../side-form-dialog/side-form-dialog.component';

@Component({
  selector: 'app-base-form',
  templateUrl: './base-form.component.html',
  styleUrls: ['./base-form.component.scss']
})
export abstract class BaseFormComponent implements OnInit, OnDestroy {

  public customNbCardClass: string = '';
  public form: UntypedFormGroup;
  public loading = false;
  public abstract readonly title: string;
  protected initialValues: any = {};
  protected subscriptions: Subscription[] = [];
  protected readonly NUMBER_VALIDATORS = [Validators.pattern(/^[0-9]*$/)];
  protected readOnly: boolean = false;

  constructor(
    protected nbDialogRef: NbDialogRef<BaseFormComponent>,
    protected dialogService: NbDialogService,
    protected translate: TranslateService,
  ) { }

  ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  public fieldValueChanged(field: string): boolean {
    const currentValue = this.form.getRawValue()[field];
    const initialValue = this.initialValues[field];
    return !R.equals(initialValue, currentValue);
  }

  public abstract anyFieldValueChanged(): void | boolean;

  public abstract onSubmit(): void;

  public abstract goToAudit(): void;

  protected abstract setUpAvailableValues(): void;

  public close(result?: unknown): void {
    this.customNbCardClass = 'slide-out';
    // Wait for the animation to finish before closing the dialog;
    setTimeout(() => this.nbDialogRef.close(result), 150);
  }

  protected initializeBackdropClick(): void {
    this.subscriptions.push(
      this.nbDialogRef.onBackdropClick.subscribe(() => {
        this.confirmClose()
      })
    )
  }

  /**
   * Whether closing the form right now would discard something the user did.
   * Defaults to anyFieldValueChanged(). Override when that method is also used
   * to drive other UI (e.g. showing a "Create" button while in add mode) and
   * therefore can't be trusted as-is to answer "is there anything to lose here".
   */
  protected hasUnsavedChanges(): boolean {
    return !!this.anyFieldValueChanged();
  }

  protected confirmClose(): void {
    if (this.hasUnsavedChanges() && !this.readOnly) {
      this.dialogService.open(
        SideFormDialogComponent,
        {
          autoFocus: false,
          closeOnBackdropClick: false,
          context: {
            title: this.translate.instant('Unregistered changes'),
            content: this.translate.instant('Would you like to exit ?'),
          },
        }
      ).onClose.subscribe((confirmation: boolean) => {
        if (confirmation) {
          this.close();
        } else {
          return
        }
      });
    } else {
      this.close()
    }
  }

}
